require('./../run.js');

// from webpack
var PROJECT_CONFIG = CONFIG;

var PATH = PROJECT_CONFIG.PATH;

// angular config
app
  .config(['$httpProvider', '$compileProvider', '$locationProvider', function ($httpProvider, $compileProvider, $locationProvider) {
    $locationProvider.hashPrefix('');
    $httpProvider.defaults.withCredentials = true;
    $compileProvider.debugInfoEnabled(true);
  }]);

// apps config
app
  .constant('SCREENSIZE', {
    xs: 480,
    sm: 768,
    md: 1025,
    lg: 1200
  })
  .constant('PATH', PATH)
  .constant('FORMAT', {
    money: '$0,0.00',
    units: '0.00',
    percent: '0.00%',
    dateApi: 'YYYY-MM-DD',
    usDate: 'MM/DD/YYYY'
  })
  .constant('SIGN_IN_URL', 'signin/index.html')
  .constant('INTERCOME_APP_ID', 'xltqrbw2')
  /*
    These names are used in transaction description
    which must not to have 2 equal names
    so we disallow adding vendor with these names
  */
  .constant('UNALLOWED_VENDOR_NAMES', [
    'Vendor Payment',
    'Distribution',
    'Payroll',
    'Sales Deposit',
    'Vendor Credit',
    'Equity Contribution',
    'Loan',
    'Credit Card Payment',
    'Cash Withdrawal',
    'Deposit Adjustment',
    'Bank Transfer'
  ])
  .constant('PERIOD_RANGE', [
    'thisPeriod',
    'lastPeriod',
    'thisYearPeriods',
    'lastYearPeriods'
  ])
  .constant('PERIOD_RANGE_DATA_AVAILABLE', [
    'latestPeriod',
    'periodBeforeLatest',
    'thisYearAvailablePeriods',
    'lastYearPeriods'
  ])
  .constant('FISCAL_RANGE', [
    'thisMonth',
    'lastMonth',
    'thisYear',
    'lastYearFiscal'
  ])
  .constant('FISCAL_RANGE_DATA_AVAILABLE', [
    'latestAvailableMonth',
    'monthBeforeLatestAvailableMonth',
    'thisYearAvailable',
    'lastYearFiscal'
  ])
  .constant('GA_KEY', 'UA-110783318-1')
  .constant('NON_ACCOUNTING_TJA_TYPE', 6)
  .constant('BILL_CREDIT_ACCOUNT', 'Accounts Payable')
  .constant('MOBILE_DEVICE', /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i)
  .constant('TJA_DETAIL_TYPE_IDS', {
    CASH: 1,
    INVENTORY: 3,
    SALES: 17,
    COGS: 18,
    LABOR: 19,
    OPERATING_EXPENSE: 20,
    OTHER_INCOME: 21,
    OTHER_EXPENSES: 22,
    COMPS: 23
  })
  .constant('SPECIAL_PURPOSE', {
    CASH: 'Cash',
    INVENTORY: 'inventory',
    SALES: 'Sales',
    COGS: 'COGS',
    LABOR: 'Labor',
    AP: 'AP',
    CC: 'CC',
    CSD: 'CSD',
    CCSD: 'CCSD',
    CASH_OVER_UNDER: 'cashoverunder',
    PROCESSINGFEES: 'processingfees',
  })
  .constant('ADMIN_PAGES', [
    'reconciliations',
    'transactionanalysis'
  ])
  .constant('MENU_NAVIGATION', [{
    // ADMIN
    title: 'Account Management',
    url: 'accountmanagement',
    permissions: {
      resource: 'management'
    },
    icon: 'glyphicon glyphicon-globe'
  }, {
    title: 'Task Management',
    url: 'taskmanagement',
    permissions: {
      resource: 'management'
    },
    icon: 'glyphicon icon-calendar'
  }, {
    title: 'Transaction Management',
    url: 'transactionmanagement',
    permissions: {
      resource: 'transactionmanagement'
    },
    icon: 'glyphicon icon-calendar'
  }, {
    title: 'Sales Quotes',
    url: 'quotes',
    permissions: {
      role: 'admin'
    },
    icon: 'glyphicon glyphicon-list-alt'
  }, {
    title: 'Activity Log',
    url: 'activitylog',
    permissions: {
      resource: 'activitylog'
    },
    icon: 'glyphicon icon-calendar'
  }, {
    title: 'System Settings',
    url: 'systemsettings',
    permissions: {
      resource: 'systemsettings',
      role: 'superAdmin'
    },
    icon: 'glyphicon glyphicon-wrench'
  }, {
    title: 'User Settings',
    url: 'usersettings',
    permissions: {
      resource: 'usersettings',
      role: 'admin'
    },
    icon: 'glyphicon glyphicon-wrench'
  },
    {
      title: 'Admin Reports',
      url: 'accountingreports',
      permissions: {
        role: 'middleAdmin'
      },
      icon: 'glyphicon glyphicon-stats'
    }, {
      // USER
      title: 'Dashboard',
      url: 'dashboard',
      permissions: {
        resource: 'dashboard'
      },
      icon: 'glyphicon-dashboard',
      keycode: [248, 79]
    }, {
      title: 'Daily Summary',
      url: 'ds',
      permissions: {
        resource: 'summary'
      },
      icon: 'glyphicon-list',
      keycode: [8706, 68]
    }, {
      title: 'Transactions',
      url: 'transactions',
      permissions: {
        resource: 'purchase'
      },
      icon: 'glyphicon-list',
      keycode: [8224, 84]
    }, {
      title: 'Payables',
      url: 'payables',
      permissions: {
        resource: ['billsmanagement', 'paymentsmanagement', 'vendorsmanagement']
      },
      icon: 'glyphicon-list',
      keycode: [960, 80]
    }, {
      title: 'Journal',
      url: 'journal',
      permissions: {
        resource: 'journal'
      },
      icon: 'glyphicon-list',
      keycode: [8710, 74]
    }, {
      title: 'Inventory',
      url: 'inventory',
      permissions: {
        resource: 'inventoryview'
      },
      icon: 'glyphicon-list',
      keycode: [8730, 73, 86]
    }, {
      title: 'Analytics',
      url: 'reports',
      icon: 'glyphicon-stats',
      keycode: [229, 65],
      hiddenitems: [{
        url: 'accountingreports',
        permissions: {
          resource: 'accountingreports'
        }
      }, {
        url: 'companyreports',
        permissions: {
          resource: 'reportcenter'
        }
      }, {
        url: 'reports',
        permissions: {
          resource: 'reportcenter'
        }
      }]
    }, {
      title: 'Files',
      url: 'files',
      permissions: {
        resource: 'filemanager'
      },
      icon: 'glyphicon-file',
      keycode: [402, 70]
    }, {
      title: 'Settings',
      url: 'settings',
      icon: 'glyphicon-cog',
      keycode: [223, 83],
      permissions: {
        resource: [
          'companyprofile', 'users', 'stores',
          'linkedaccounts', 'classifications', 'classificationrules',
          'summaryconstruct', 'inventoryedit', 'menu',
          'classifications', 'classificationrules'
        ]
      }
    }
    // , {
    //   title: 'Payroll',
    //   url: 'project/apps/payroll/login.html',
    //   permissions: {
    //     isSlidedInAdmin: true
    //   }
    // }
  ])
  .constant('ADMIN_TIMEZONE', 'America/Chicago')
  .constant('EMAIL_PATTERN', /^([\w-]+([\.\:\w-\+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/)
  .constant('HOLIDAYS', {
    '2019': {
      '0': [
        '2019-01-01',
        '2019-01-21'
      ],
      '1': [
        '2019-02-18'
      ],
      '4': [
        '2019-05-27'
      ],
      '6': [
        '2019-07-04'
      ],
      '8': [
        '2019-09-02'
      ],
      '9': [
        '2019-10-14'
      ],
      '10': [
        '2019-11-11',
        '2019-11-28'
      ],
      '11': [
        '2019-12-25'
      ]
    },
    '2020': {
      '0': [
        '2020-01-01',
        '2020-01-20'
      ],
      '1': [
        '2020-02-17'
      ],
      '4': [
        '2020-05-25'
      ],
      '8': [
        '2020-09-07'
      ],
      '9': [
        '2020-10-12'
      ],
      '10': [
        '2020-11-11',
        '2020-11-26'
      ],
      '11': [
        '2020-12-25'
      ]
    },
    '2021': {
      '0': [
        '2021-01-01',
        '2021-01-18'
      ],
      '1': [
        '2021-02-15'
      ],
      '4': [
        '2021-05-31'
      ],
      '6': [
        '2021-07-05'
      ],
      '8': [
        '2021-09-06'
      ],
      '9': [
        '2021-10-11'
      ],
      '10': [
        '2021-11-11',
        '2021-11-25'
      ],
      '11': [
        '2021-12-24',
        '2021-12-31'
      ]
    },
    '2022': {
      '0': [
        '2022-01-17'
      ],
      '1': [
        '2022-02-21'
      ],
      '4': [
        '2022-05-30'
      ],
      '6': [
        '2022-07-04'
      ],
      '8': [
        '2022-09-05'
      ],
      '9': [
        '2022-10-10'
      ],
      '10': [
        '2022-11-11',
        '2022-11-24'
      ],
      '11': [
        '2022-12-26'
      ]
    },
    '2023': {
        '0': [
            '2023-01-02',
            '2023-01-16'
          ],
          '1': [
            '2023-02-20'
          ],
          '4': [
            '2023-05-29',
            '2023-06-19',
          ],
          '6': [
            '2023-07-04'
          ],
          '8': [
            '2023-09-04'
          ],
          '9': [
            '2023-10-09'
          ],
          '10': [
            '2023-11-11',
            '2023-11-23'
          ],
          '11': [
            '2023-12-25'
          ]
      },
      '2024': {
        '0': [
            '2023-01-01',
            '2023-01-15'
          ],
          '1': [
            '2023-02-19'
          ],
          '4': [
            '2023-05-27',
            '2023-06-19',
          ],
          '6': [
            '2023-07-04'
          ],
          '8': [
            '2023-09-02'
          ],
          '9': [
            '2023-10-14'
          ],
          '10': [
            '2023-11-11',
            '2023-11-28'
          ],
          '11': [
            '2023-12-25'
          ]
      },
      '2025': {
        '0': [
            '2023-01-01',
            '2023-01-20'
          ],
          '1': [
            '2023-02-17'
          ],
          '4': [
            '2023-05-26',
            '2023-06-19',
          ],
          '6': [
            '2023-07-04'
          ],
          '8': [
            '2023-09-01'
          ],
          '9': [
            '2023-10-13'
          ],
          '10': [
            '2023-11-11',
            '2023-11-27'
          ],
          '11': [
            '2023-12-25'
          ]
      },
      '2026': {
        '0': [
            '2023-01-01',
            '2023-01-19'
          ],
          '1': [
            '2023-02-16'
          ],
          '4': [
            '2023-05-25',
            '2023-06-19',
          ],
          '6': [
            '2023-07-04'
          ],
          '8': [
            '2023-09-07'
          ],
          '9': [
            '2023-10-12'
          ],
          '10': [
            '2023-11-11',
            '2023-11-26'
          ],
          '11': [
            '2023-12-25'
          ]
      },
      '2027': {
        '0': [
            '2023-01-01',
            '2023-01-18'
          ],
          '1': [
            '2023-02-15'
          ],
          '4': [
            '2023-05-31',
            '2023-06-19',
          ],
          '6': [
            '2023-07-04'
          ],
          '8': [
            '2023-09-06'
          ],
          '9': [
            '2023-10-11'
          ],
          '10': [
            '2023-11-11',
            '2023-11-25'
          ],
          '11': [
            '2023-12-25'
          ]
      }
  });

// angular 3rd parties config
try {
  angular.module('mgcrea.ngStrap')
    .config(["$datepickerProvider", "$modalProvider", "$typeaheadProvider", "$selectProvider", function ($datepickerProvider, $modalProvider, $typeaheadProvider, $selectProvider) {
      angular.extend($datepickerProvider.defaults, {
        templateUrl: PATH.common + 'templates/datepicker.tpl.html',
        timezone: 'UTC',
        keyboard: false
      });

      $typeaheadProvider.defaults.templateUrl = PATH.common + 'templates/typeahead.tpl.html';
      $typeaheadProvider.defaults.minLength = 1;
      $typeaheadProvider.defaults.limit = 100000;

      $selectProvider.defaults.templateUrl = PATH.common + 'templates/select.tpl.html';

      $modalProvider.defaults.backdrop = 'static';
      $modalProvider.defaults.keyboard = false;
    }]);
} catch (error) {
  console.error(error);
}

// Swipe left-right
try {
  angular.module('angular-gestures')
    .config(["hammerDefaultOptsProvider", function (hammerDefaultOptsProvider) {
      hammerDefaultOptsProvider.set({
        recognizers: [
          [Hammer.Swipe, { velocity: 0.1, threshold: 5 }],
          [Hammer.Tap, { time: 500 }]
        ]
      });
    }]);
} catch (error) {
  console.error(error);
}

try {
  angular.module('ngTagsInput')
    .config(["tagsInputConfigProvider", function (tagsInputConfigProvider) {
      tagsInputConfigProvider.setDefaults('tagsInput', {
        placeholder: '',
        template: PATH.common + 'templates/tags-input.tpl.html'
      });
      tagsInputConfigProvider.setActiveInterpolation('tagsInput', {
        placeholder: true
      });
    }]);
} catch (error) {
  console.error(error);
}

// common module with project dependencies
angular.module('project', [
  'ngTagsInput',
  'LocalStorageModule',
  'mgcrea.ngStrap',
  'ui.router',
  'ngAnimate',
  'angular-gestures',
  'ngSanitize'
]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/config/config.common.js